import classNames from 'classnames';
import styles from './Checkbox.module.css';
import { InputHTMLAttributes } from 'react';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
    name?: string;
}

export const Checkbox = ({
    children,
    className,
    name,
    required = false,
    ...rest
}: Props) => {
    return (
        <label className={classNames(styles.container, className)}>
            <input
                className={classNames(styles.input)}
                required={required}
                type="checkbox"
                {...rest}
            />
            <span className={styles.checkbox} />
            {!!children && <span className={styles.label}>{children}</span>}
        </label>
    )
}
